<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage" id="epi01">
<div class="epigraph">
<p class="epigraphText">“Consider well. He is a Prince!”</p>
<p class="epigraphText">“More! He is a Man!”</p>
<p class="epigraphSource">—<em class="italic">Die Zauberflöte</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi.vue?8b454ecc